var map = {
	"./assets/PH-MAP 1.png": 97553,
	"./assets/Traxionpay-digicoop-coopnet.png": 57911,
	"./assets/aboutcoopnet/accesible.c0d72528.png": 83522,
	"./assets/aboutcoopnet/coop-centric.50c7086e.png": 89987,
	"./assets/aboutcoopnet/empowered.ca0e59a1.png": 72626,
	"./assets/aboutcoopnet/innovative.29785f98.png": 17869,
	"./assets/aggregatedpartners/partners.png": 25367,
	"./assets/aggregatedpartners/partners2.png": 22008,
	"./assets/cat_logo.webp": 55449,
	"./assets/contactus/coopnet-bg.c9a3a6f8.png": 93556,
	"./assets/contactus/manila.jpg": 59367,
	"./assets/contactus/not used/pic.5d925de4.png": 32097,
	"./assets/contactus/not used/traxion-group-photo.png": 97434,
	"./assets/contactus/tagum-and-davao.jpg": 22321,
	"./assets/coop-mobile.791fa1f6.png": 92060,
	"./assets/coopnet-logo-2.afcec3ef.png": 77962,
	"./assets/coopnet-logo.94f920f2.png": 26527,
	"./assets/coopnet.png": 43413,
	"./assets/coopnet_logo_colored.png": 15677,
	"./assets/coopnetmachine/CTM-Animation.gif": 85745,
	"./assets/coopnetmachine/banktransfer.png": 95298,
	"./assets/coopnetmachine/billspayment.png": 37433,
	"./assets/coopnetmachine/cashin.png": 86050,
	"./assets/coopnetmachine/coopnet-bg.c9a3a6f8.png": 77973,
	"./assets/coopnetmachine/eload.png": 58353,
	"./assets/coopnetmachine/fundtransfer.png": 88807,
	"./assets/coopnetmachine/loanapplication.png": 18456,
	"./assets/coopnetmachine/more.png": 71384,
	"./assets/coopnetmachine/remittance.png": 57619,
	"./assets/ctm-sidever.ea53acd5.png": 90690,
	"./assets/digicoop.png": 33357,
	"./assets/dragonpaysuccesspage/digicoop_online_payment_flatline.png": 38898,
	"./assets/dragonpaysuccesspage/online_payment_flatline.png": 26132,
	"./assets/error-image.webp": 85728,
	"./assets/footer/coopnet-logo-3.3a936e31.png": 6702,
	"./assets/footer/facebook.1ab1b99b.png": 72513,
	"./assets/footer/linkedin.76ac1988.png": 76197,
	"./assets/footer/twitter.a16bac27.png": 76669,
	"./assets/footer/youtube.png": 81480,
	"./assets/gcash_logo.webp": 61746,
	"./assets/home-bg.a2b2cbed.png": 70287,
	"./assets/meta/coopnet-banner.png": 24698,
	"./assets/meta/traxionpay-banner.png": 8341,
	"./assets/mobilebankingapp/Googleplay 1.png": 96739,
	"./assets/mobilebankingapp/appgallery 1.png": 83196,
	"./assets/mobilebankingapp/appstore 1.png": 61922,
	"./assets/mobilebankingapp/banktransfer.png": 10106,
	"./assets/mobilebankingapp/billspayment.png": 5503,
	"./assets/mobilebankingapp/cashin.png": 93850,
	"./assets/mobilebankingapp/coopnet-mobile 1.png": 5109,
	"./assets/mobilebankingapp/ellipse-background.png": 28748,
	"./assets/mobilebankingapp/eload.png": 63862,
	"./assets/mobilebankingapp/fundtransfer.png": 36549,
	"./assets/mobilebankingapp/loanapplication.png": 77952,
	"./assets/mobilebankingapp/mobilebankingapp-bg.png": 66792,
	"./assets/mobilebankingapp/mobilebankingapp-logo.png": 9398,
	"./assets/mobilebankingapp/more.png": 33684,
	"./assets/mobilebankingapp/old/coopnet-mobile 1 (2).png": 83956,
	"./assets/mobilebankingapp/old/coopnet-mobile 1.png": 11225,
	"./assets/mobilebankingapp/remittance.png": 52762,
	"./assets/ourdxbanksolutions/Coopnet Teller Machine (CTM) - Cash in Cash out.png": 88328,
	"./assets/ourdxbanksolutions/Core Banking System on SAAS model.png": 81824,
	"./assets/ourdxbanksolutions/Digital Account Opening.png": 85604,
	"./assets/ourdxbanksolutions/Disbursement System.png": 30306,
	"./assets/ourdxbanksolutions/Mobile Banking App.png": 46701,
	"./assets/ourdxbanksolutions/Payment System.png": 97986,
	"./assets/ourdxbanksolutions/Prepaid Debit Visa Card.png": 62256,
	"./assets/ourdxbanksolutions/eKYC.png": 9150,
	"./assets/ourdxbanksolutions/ewallet.png": 98619,
	"./assets/ourteam/Ann-Cuisia.png": 4834,
	"./assets/ourteam/Darwin-Pasco.png": 49395,
	"./assets/ourteam/Gari-Lenard-Santos.png": 62966,
	"./assets/ourteam/Mario-De-Guia.png": 17183,
	"./assets/ourteam/Rodel-Cayetano.png": 15788,
	"./assets/ourteam/Ronald-Cases-Morfe.png": 20452,
	"./assets/receipt_check_mark.png": 70214,
	"./assets/spinner.gif": 32328,
	"./assets/subscribe/mail.png": 97294,
	"./assets/success-logo.webp": 9337,
	"./assets/traxion-pay-black.png": 52118,
	"./assets/traxion-pay-white.png": 87975,
	"./assets/traxion.png": 10534,
	"./assets/utilities/arrow-up-solid.svg": 59374,
	"./assets/whoweserve/coopbanks.1ae62676.png": 67462,
	"./assets/whoweserve/cooperatives.f10bc990.png": 41279,
	"./assets/whoweserve/lendingcompanies.1c9a7b0d.png": 27951,
	"./assets/whoweserve/microfinance.4274c5fb.png": 77637,
	"./assets/whoweserve/ruralbanks.f17e65df.png": 75722,
	"./assets/whoweserve/savingsbanks.230dfa81.png": 83193,
	"./assets/whoweserve/thriftbanks.cad7ce52.png": 55626,
	"./assets/whycoopnet/coin 1.png": 46348,
	"./assets/whycoopnet/coin 2.png": 51947,
	"./assets/whycoopnet/coin 3.png": 83052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97148;